import type { Ref } from 'vue';
import {
  cancelIdleCallback,
  requestIdleCallback
} from '~/utils/requestIdleCallback';
import { shouldMountAppToastHost } from '~/utils/appToastHostState';
import { isDefined } from '~/utils/guards/isDefined';
import { useToastCookie } from '~/utils/useToastCookie';

export function useDeferredAppToastHost(isPdp?: Ref<boolean>) {
  let idleCallbackId: number | null = null;

  const AppToastHostComponent = defineAsyncComponent(
    () => import('~/components/global/lib/AppToastHost.vue')
  );

  const scheduleIdleMount = () => {
    if (!import.meta.client) {
      return;
    }

    idleCallbackId = requestIdleCallback(
      () => {
        shouldMountAppToastHost.value = true;
      },
      { timeout: 3000 }
    );
  };

  if (import.meta.client) {
    const toastCookie = useToastCookie();

    onMounted(() => {
      if (isPdp?.value) {
        shouldMountAppToastHost.value = true;
        return;
      }

      if (
        isDefined(toastCookie.value) &&
        toastCookie.value.context === 'cart'
      ) {
        shouldMountAppToastHost.value = true;
        return;
      }

      scheduleIdleMount();
    });

    onUnmounted(() => {
      if (idleCallbackId !== null) {
        cancelIdleCallback(idleCallbackId);
        idleCallbackId = null;
      }
    });
  }

  return {
    shouldMountAppToastHost,
    AppToastHostComponent
  };
}
